import axios from "axios";
import AppConstant from "../assets/js/AppConstant";

export const SubmitManagemnetReview = async ({ ticketId, review }) => {
  return await axios.post(
    AppConstant.MAIN_URL +
      `/marketing-claim-api/v1/ticket/${ticketId}/management-review`,
    {
      reviews: review,
    }
  );
};

export const UpdateManagementTicket = async ({ ticketId, bodyPayload }) => {
  return await axios({
    method: "patch",
    url: `/marketing-claim-api/v1/ticket/${ticketId}/management-revise`,
    data: bodyPayload,
  });
};
